import { colors } from 'css/constants';

const FormStyles = `
.form-check-input:checked {
    background-color: ${colors.blue};
    border-color: ${colors.blue};
}
`;

export default FormStyles;
